// extracted by mini-css-extract-plugin
module.exports = {"label":"FooterMenu_label__V3FNI","control":"FooterMenu_control__jndmK","item":"FooterMenu_item__7HckZ","icon":"FooterMenu_icon__8w4_D"};